<template>
    <div>
        <v-combobox v-bind="$attrs" v-model="model"
            :items="shippers" 
            :search-input.sync="search"
            hide-details
            :placeholder="childplaceholder" 
            :clearable="clearable"
            class="form-control form-control-sm" :class="childclass">
            <template v-slot:no-data>
                <v-list-item>
                    {{ loading == 'search' ? 'Buscando...' : 'No hay datos disponibles'}}
                </v-list-item>
            </template>
        </v-combobox>
    </div>
</template>
<script>
export default {
    props: {
        childplaceholder: '',
        childclass: '',
        clearable: false
    },
    data(){
        return{
            loading: '',
            search: '',
            shippers: [],
            key_up: 0,
        }
    },
    computed: {
        model: {
            get() { 
                return this.$attrs.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    },
    methods: {
        SHIPPERS: function () {
            let vue = this
            axios({
                url: '/search/shipper?query=' + vue.search,
                method: 'GET'
            })
                .then((resp) => {
                    vue.shippers = resp.data
                })
                .catch((err) => {
                    if (err.response.status === 402 || err.response.status === 404) {
                       let message = err.response ? err.response.data.message : err.message
                        vue.$swal({ toast: true, icon: 'error', title: message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    } else {
                        vue.$swal({ toast: true, icon: 'error', title: err.message, position: 'top-end', showConfirmButton: false, timer: 3000 })
                    }
                })
                .finally((resp) => {
                    vue.loading = ''
                    if (vue.shippers.length == 0) {
                        vue.shippers.push(vue.search)
                    }
                })
        },
    },
    watch: {
        search: {
            handler(value) {
                let vue = this
                vue.$emit('input', value)
                vue.loading = 'search'
                if(!value){
                    vue.key_up = 0
                    vue.shippers = []
                    vue.loading = ''
                    return
                }
                vue.key_up = value.length
                setTimeout(() => {
                    if(vue.key_up == value.length && !vue.user){
                        vue.SHIPPERS()
                        vue.key_up = 0
                    }
                }, 500)
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/input/SearchShipper.vue